@if (isOverlayOpen) {
<div class="backdrop"></div>
<div class="overlay" role="dialog" aria-modal="true">
  <div class="overlay-header straightline-overlay">
    <div>
      <h5>Contact</h5>
    </div>
    <div class="close-button">
      <up-icon name="close" (click)="closeOverlay()"></up-icon>
    </div>
  </div>
  <div class="overlay-content">
    <div class="card_contact">
      <!-- <div class="name_email">
                    <strong>Name</strong>
                    <span>{{contactName}}</span>
                </div> -->
      <div class="name_email">
        <up-icon name="email" slot="icon"></up-icon>
        <span class="email-gap">
          <a class="email-style "
            href="mailto:{{ contactEmail }}"
            onmouseover="this.style.textDecoration='underline'"
            onmouseout="this.style.textDecoration='none'"
          >
            {{ contactEmail }}
          </a>
        </span>
      </div>
      <div class="phone_details">
        <up-icon name="phone" slot="icon"></up-icon>
        <span>{{ contactPhone }}</span>
      </div>
    </div>
    <div class="button-row">
      <up-button button-style="contained">
        <button type="submit" (click)="closeOverlay()">Ok</button>
      </up-button>
    </div>
  </div>
</div>
}
